import { StrictMode, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { OpenAPI } from './services/generatedApi';
//Most important
const ObjectPage = lazy(() => import('./pages/ObjectPage'));
const ForSaleComponent = lazy(
  () =>
    import(
      './components/ObjectsListComponents/FilterComponents/ForSaleComponent'
    )
);
// components
const SPObjectListSmallProvider = lazy(
  () => import('./components/MyPagesComponents/SPObjectListSmallProvider')
);
const SPObjectListProvider = lazy(
  () => import('./components/MyPagesComponents/SPObjectListProvider')
);
const CreateSearchProfileProvider = lazy(
  () => import('./components/MyPagesComponents/CreateSearchProfileProvider')
);

const SignUpValueCheckProvider = lazy(
  () => import('./forms/SignUpValueCheckProvider')
);
const QuitValueCheckProvider = lazy(
  () => import('./forms/QuitValueCheckProvider')
);

const LoggedIn = lazy(() => import('./components/GeneralComponents/LoggedIn'));

const OfficeEstatesComponent = lazy(
  () => import('./components/ObjectsListComponents/OfficeEstatesComponent')
);
const AutocompleteStartpageComponent = lazy(
  () =>
    import('./components/ObjectsListComponents/AutocompleteStartpageComponent')
);

const SpontaneousCareerForm = lazy(
  () => import('./forms/SpontaneousCareerForm')
);
const SpontaneousStudentForm = lazy(
  () => import('./forms/SpontaneousStudentForm')
);
const SpontaneousFranchiseForm = lazy(
  () => import('./forms/SpontaneousFranchiseForm')
);
const CareerForm = lazy(() => import('./forms/CareerForm'));

const EvaluateResidenceForm = lazy(
  () => import('./forms/EvaluateResidenceForm')
);
const InterestForm = lazy(() => import('./forms/InterestForm'));
const AreaCheckForm = lazy(() => import('./forms/AreaCheckForm'));
const HeadStartForm = lazy(() => import('./forms/HeadStartForm'));
const FinalPriceWatchForm = lazy(() => import('./forms/FinalPriceWatchForm'));

const ValueCheckForm = lazy(() => import('./forms/ValueCheckForm'));
const EditProfileProvider = lazy(() => import('./forms/EditProfileProvider'));
const GeneralFormVitec = lazy(() => import('./forms/GeneralFormVitec'));

const QuitValueCheck = lazy(() => import('./forms/QuitValueCheck'));
const EditValueCheck = lazy(() => import('./forms/EditValueCheck'));
const CompleteProfileForm = lazy(
  () =>
    import('./components/MyPagesComponents/MyPagesForms/CompleteProfileForm')
);

const OfficeHero = lazy(
  () => import('./components/OfficeComponents/OfficeHero')
);
const CampaignsAndNewsPage = lazy(
  () => import('./components/OfficeComponents/CampaignsAndNewsPage')
);
const OfficeDescription = lazy(
  () => import('./components/OfficeComponents/OfficeDescription')
);
const OfficeCampaignsAndNewsBlock = lazy(
  () => import('./components/OfficeComponents/OfficeCampaignsAndNewsBlock')
);
const ClosestOffice = lazy(
  () => import('./components/OfficeComponents/ClosestOffice')
);

const BrokerProfile = lazy(
  () => import('./components/BrokerComponents/BrokerProfile')
);
const Rekai = lazy(() => import('./components/Blocks/Rekai'));
const Brokers = lazy(() => import('./components/BrokerComponents/Brokers'));
const BankPuff = lazy(() => import('./components/OfficeComponents/BankPuff'));

const OfficeBrokerSearch = lazy(
  () => import('./components/OfficeComponents/OfficeBrokerSearch')
);

const PressReleases = lazy(() => import('./components/Press/PressReleases'));
const PressReleasesCollection = lazy(
  () => import('./components/Press/PressReleasesCollection')
);
const SingleTTNewsPage = lazy(
  () => import('./components/Press/SingleTTNewsPage')
);
const NewUserProvider = lazy(
  () => import('./components/MyPagesComponents/Components/NewUserProvider')
);
const MyPagesClosestOfficeProvider = lazy(
  () =>
    import(
      './components/MyPagesComponents/Components/MyPagesClosestOfficeProvider'
    )
);
const MyPagesReloadUser = lazy(
  () =>
    import(
      './components/MyPagesComponents/Components/Objectview/MyPagesReloadUser'
    )
);
const MyPagesBoughtObjectProvider = lazy(
  () =>
    import(
      './components/MyPagesComponents/Components/MyPagesBoughtObjectProvider'
    )
);
const MyPagesBrokers = lazy(
  () =>
    import(
      './components/MyPagesComponents/Components/Objectview/MyPagesBrokers'
    )
);
const MyPagesSoldObjectEstate = lazy(
  () =>
    import(
      './components/MyPagesComponents/Components/Objectview/MyPagesSoldObjectEstate'
    )
);
const MyPagesMyEstatesProvider = lazy(
  () =>
    import('./components/MyPagesComponents/Components/MypagesMyEstatesProvider')
);
const OfficeBlockList = lazy(
  () => import('./components/OfficeComponents/OfficeBlockList')
);
const QuestionList = lazy(
  () => import('./forms/MyPagesAssignments/QuestionList/QuestionList')
);
const LogoutButton = lazy(
  () => import('./components/MyPagesComponents/Components/LogoutButton')
);
const MyPagesBrokersProvider = lazy(
  () =>
    import(
      './components/MyPagesComponents/Components/Objectview/MyPagesBrokersProvider'
    )
);
const MyPagesObjectSellingProvider = lazy(
  () =>
    import(
      './components/MyPagesComponents/Components/Objectview/MyPagesObjectSellingProvider'
    )
);
const MyPagesObjectBiddingProvider = lazy(
  () =>
    import(
      './components/MyPagesComponents/Components/Objectview/MyPagesObjectBiddingProvider'
    )
);
const MyPagesObjectSellingOrBuyingProvider = lazy(
  () =>
    import(
      './components/MyPagesComponents/Components/Objectview/MyPagesObjectSellingOrBuyingProvider'
    )
);
const ConsentContainer = lazy(
  () =>
    import(
      './components/MyPagesComponents/Components/DataShare/ConsentContainer'
    )
);

//pages
const MyPagesSellerProvider = lazy(
  () => import('./pages/MyPagesSellerProvider')
);
const MyPagesBuyerProvider = lazy(() => import('./pages/MyPagesBuyerProvider'));
const MyPagesBidderProvider = lazy(
  () => import('./pages/MyPagesBidderProvider')
);
const MyPagesViewingProvider = lazy(
  () => import('./pages/MyPagesViewingProvider')
);
const HomeAssignment = lazy(
  () => import('./forms/MyPagesAssignments/HomeAssignment/HomeAssignment')
);
const DeclarationBasis = lazy(
  () => import('./forms/MyPagesAssignments/DeclarationBasis/DeclarationBasis')
);

const QuestionListHouse = lazy(
  () => import('./forms/MyPagesAssignments/QuestionList/QuestionListHouse')
);
const QuestionListCooperative = lazy(
  () => import('./forms/MyPagesAssignments/QuestionList/QuestionListHouse')
);
const BrokerLogin = lazy(() => import('./forms/LogIn/BrokerLogin'));
const AutoLoginB2C = lazy(() => import('./forms/LogIn/AutoLoginB2C'));
const OfficeMap = lazy(() => import('./components/OfficeComponents/OfficeMap'));
const LoggedInAsCustomerProvider = lazy(
  () =>
    import(
      './components/MyPagesComponents/BrokerLogin/LoggedInAsCustomerProvider'
    )
);
const LoggedInAsCustomerAlert = lazy(
  () =>
    import('./components/MyPagesComponents/BrokerLogin/LoggedInAsCustomerAlert')
);
const SpeculationCheckProvider = lazy(
  () =>
    import('./components/SpeculationCheckComponents/SpeculationCheckProvider')
);
const OfficeListContextProvider = lazy(
  () =>
    import('./components/OfficeComponents/Context/OfficeListContextProvider')
);
const BrokerProfilePageNew = lazy(
  () => import('./pages/BrokerPages/BrokerProfilePageNew')
);

const OfficePageProvider = lazy(
  () => import('./pages/BrokerPages/OfficePageProvider')
);
const CountyPage = lazy(() => import('./pages/BrokerPages/CountyPage'));
const ContactForm = lazy(() => import('./forms/ContactForm'));
const ContactFormProvider = lazy(
  () => import('./pages/BrokerPages/ContactFormProvider')
);

const BrokerCalendar = lazy(
  () => import('./components/BrokerCalendar/BrokerCalendar')
);

// eslint-disable-next-line
const components: Record<string, any> = {
  objectPage: ObjectPage,
  forSale: ForSaleComponent,
  officeEstates: OfficeEstatesComponent,
  careerForm: CareerForm,
  spontaneousCareerForm: SpontaneousCareerForm,
  spontaneousStudentForm: SpontaneousStudentForm,
  spontaneousFranchiseForm: SpontaneousFranchiseForm,
  finalPriceWatchForm: FinalPriceWatchForm,
  headStartForm: HeadStartForm,
  interestForm: InterestForm,
  evaluateResidenceForm: EvaluateResidenceForm,
  valueCheckForm: ValueCheckForm,
  autocomplete: AutocompleteStartpageComponent,
  loggedIn: LoggedIn,
  areaCheckForm: AreaCheckForm,
  generalFormVitec: GeneralFormVitec,
  completeProfileForm: CompleteProfileForm,
  editValueCheck: EditValueCheck,
  editProfileProvider: EditProfileProvider,
  homeAssignment: HomeAssignment,
  declarationBasis: DeclarationBasis,
  questionListHouse: QuestionListHouse,
  questionListCooperative: QuestionListCooperative,
  officeMap: OfficeMap,
  officeHero: OfficeHero,
  campaignsAndNewsPage: CampaignsAndNewsPage,
  officeDescription: OfficeDescription,
  officeCampaignsAndNewsBlock: OfficeCampaignsAndNewsBlock,
  closestOffice: ClosestOffice,
  brokers: Brokers,
  brokerProfile: BrokerProfile,
  bankPuff: BankPuff,
  officeBrokerSearch: OfficeBrokerSearch,
  pressReleases: PressReleases,
  pressReleasesCollection: PressReleasesCollection,
  singleTTNewsPage: SingleTTNewsPage,
  newUserProvider: NewUserProvider,
  myPagesClosestOfficeProvider: MyPagesClosestOfficeProvider,
  myPagesBoughtObjectProvider: MyPagesBoughtObjectProvider,
  myPagesBrokers: MyPagesBrokers,
  myPagesSoldObjectEstate: MyPagesSoldObjectEstate,
  myPagesMyEstatesProvider: MyPagesMyEstatesProvider,
  officeBlockList: OfficeBlockList,
  questionList: QuestionList,
  spObjectListSmallProvider: SPObjectListSmallProvider,
  spObjectListProvider: SPObjectListProvider,
  logoutButton: LogoutButton,
  createSearchProfileProvider: CreateSearchProfileProvider,
  myPagesObjectSellingProvider: MyPagesObjectSellingProvider,
  myPagesObjectBiddingProvider: MyPagesObjectBiddingProvider,
  myPagesObjectSellingOrBuyingProvider: MyPagesObjectSellingOrBuyingProvider,
  signUpValueCheckProvider: SignUpValueCheckProvider,
  quitValueCheckProvider: QuitValueCheckProvider,
  myPagesBrokersProvider: MyPagesBrokersProvider,
  myPagesBuyerProvider: MyPagesBuyerProvider,
  myPagesSellerProvider: MyPagesSellerProvider,
  myPagesBidderProvider: MyPagesBidderProvider,
  myPagesViewingProvider: MyPagesViewingProvider,
  loggedInAsCustomerProvider: LoggedInAsCustomerProvider,
  loggedInAsCustomerAlert: LoggedInAsCustomerAlert,
  brokerLogin: BrokerLogin,
  rekai: Rekai,
  autoLoginB2C: AutoLoginB2C,
  speculationCheck: SpeculationCheckProvider,
  myPagesReloadUser: MyPagesReloadUser,
  consentContainer: ConsentContainer,
  officeListContextProvider: OfficeListContextProvider,
  brokerProfilePageNew: BrokerProfilePageNew,
  officePageProvider: OfficePageProvider,
  contactForm: ContactForm,
  contactFormProvider: ContactFormProvider,
  countyPage: CountyPage,
  brokerCalendar: BrokerCalendar,
};

export const reactComponentArray = () => {
  Array.from(document.querySelectorAll('[class^="lff-component-"]')).forEach(
    (x) => {
      const componentName = x.className.split('lff-component-')?.[1];
      const Component = components[componentName];

      if (!Component) return null;

      let data = {};
      const dataString = x.getAttribute('data-data');

      if (dataString?.length) {
        try {
          data = JSON.parse(dataString);
        } catch {
          console.log('cannot parse component data');
        }
      }

      OpenAPI.BASE = 'https://app-lansfast-api.azurewebsites.net';
      const client = new QueryClient({
        defaultOptions: {
          queries: {
            cacheTime: 300000,
            refetchOnWindowFocus: false,
          },
        },
      });

      const root = createRoot(x);
      root.render(
        <StrictMode>
          <QueryClientProvider client={client}>
            <Component {...data} />
          </QueryClientProvider>
        </StrictMode>
      );
    }
  );
};
